import { BondPriceNominal, Yield, asBondPriceNominal, asYield } from "@goodfill/domain-properties";
import { Flex, InputNumber, Span } from "@goodfill/ui-components";

import Decimal from "decimal.js";
import { FormValidationResult } from "../../../../form/formValidation";
import { FormValidationComponent } from "../../../../form/FormValidationComponent";
import { Popover } from "../../../../ui-components/tooltip/Popover";
import "./CustomOrderPriceVsYield.scss";

export const CustomOrderPriceVsYield = (props: {
  validation: FormValidationResult;
  priceVsYield: "price" | "yield";
  setPriceVsYield: (value: "price" | "yield") => void;
  customPrice: BondPriceNominal;
  setCustomPrice: (value: BondPriceNominal) => void;
  customYield: Yield;
  setCustomYield: (value: Yield) => void;
  disabled: boolean;
  ResetLink: React.ReactNode;
}) => {
  return (
    <Flex direction="row" gap={2}>
      <Flex width={36} items="start" direction="col">
        <Span size="base" font="medium" className="px-0-important custom-fonts">
          <Popover
            content={
              <div>
                <p className="mb-0-important px-4 py-4 text-white">
                  Order Denomination <br />
                  <br />
                  You can create orders denominated in "Yield" or in "Price".
                </p>
              </div>
            }
          />
          Order Price
        </Span>
        <InputNumber
          data-testid="customPriceInput"
          border={"neutral"}
          width={32}
          value={props.customPrice.mul(100).toDecimalPlaces(2).toNumber()}
          setValue={(value) => {
            if (value !== null) {
              props.setCustomPrice(asBondPriceNominal(new Decimal(value).div(100)));
            }
          }}
          className="input-border"
          leftIcon="$"
        />
      </Flex>
      <Flex width={40} items="start" direction="col">
        <Span size="base" font="medium" className="px-0-important custom-fonts">
          <Popover
            content={
              <div>
                <p className="mb-0-important px-4 py-4 text-white">
                  Order Denomination <br />
                  <br />
                  You can create orders denominated in "Yield" or in "Price".
                </p>
              </div>
            }
          />
          Order Yield
        </Span>
        <InputNumber
          data-testid="customYieldInput"
          border="neutral"
          width={32}
          value={props.customYield.mul(100).toDecimalPlaces(2).toNumber()}
          setValue={(value) => {
            if (value === null) return;
            props.setCustomYield(asYield(new Decimal(value).div(100)));
          }}
          className="input-border"
          rightIcon="%"
        />
        <div className="px-0-important w-32 flex">
          <FormValidationComponent
            validation={props.validation}
            className="px-0-important whitespace-unset-important"
          />
        </div>
      </Flex>
      {props.ResetLink}
    </Flex>
  );
};
